import { Component, OnInit } from '@angular/core';
import {AuthService} from '../../service/auth.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

    formData: FormGroup;
    loading: boolean = false;

    submitted: boolean = false;

    constructor(private fb: FormBuilder, private auth: AuthService, private router: Router) {
        this.formData = this.fb.group({
            'email': new FormControl('', [Validators.required, Validators.email]),
            'password': new FormControl('', [Validators.required, Validators.pattern('.{8,}')]),
            'repeat_password': new FormControl('', [Validators.required, this.passValidation.bind(this.formData)])
        });
    }

    changePassword(): void {
        if(!this.formData.valid){
            this.submitted = true;
            return;
        }

        this.loading = true;
        this
            .auth
            .changePasswordFromEmail(this.formData.value['email'], this.formData.value['password'])
            .subscribe(
                (result) => {
                    if(result.hasOwnProperty('error')){
                        Swal('Change password', result.error, 'error');
                        this.loading = false;
                    }
                    else{
                        Swal('Change password', 'Password has been changes successfully. Now you can log in with you new password', 'success');
                        this.router.navigateByUrl('/pages/login');
                    }
                }
            )
    }

    passValidation(control: FormControl): { [s: string]: boolean } {
        if (control.parent) {
            const passwd = control.parent.value.password;
            const rep_passwd = control.value;

            if (passwd !== rep_passwd) {
                return {
                    password_mismatch: true
                }
            }
        }
        return null;
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/core/components/change-password/change-password.component.ts